import { Routes } from '@angular/router';
import { principalRoute } from './shared/utilities/const/route';
import { authGuard } from './core/guards/auth-guard';
import { loginGuard } from './core/guards/login-guard';

export const routes: Routes = [
  {
    path: '',
    title: 'Sanzioni Amministrative',
    canActivate: [loginGuard],
    loadComponent: () => import('./features/login/components/pre-login'),
  },
  {
    path: principalRoute.verbalList,
    title: 'Sanzioni Amministrative - Polizia Stradale',
    canActivate: [authGuard],
    data: { breadcrumb: 'Sanzioni amministrative - Polizia Stradale' },
    children: [
      {
        path: '',
        title: 'Lista Verbali',
        loadComponent: () => import('./features/verbal/components/verbal-list/verbal-list'),
      },
      {
        path: 'dettaglio-verbale/:id',
        title: 'Dettaglio Verbale',
        data: { breadcrumb: 'Verbale' },
        loadComponent: () => import('./features/verbal/components/verbal-detail/verbal-detail'),
      },
      {
        path: 'invio-modulo/:id',
        title: 'Invio Modulo',
        data: { breadcrumb: 'Invio Modulo' },
        loadComponent: () => import('./features/verbal/components/submit-form/submit-form'),
      },
    ],
  },
  {
    path: principalRoute.login,
    title: 'Accesso - Sanzioni Amministrative',
    loadComponent: () => import('./features/login/components/login'),
    canActivate: [loginGuard],
  },
  {
    path: principalRoute.serverUnavailable,
    title: 'Servizio non disponibile',
    loadComponent: () =>
      import('./features/error-page/components/server-unavailable/server-unavailable'),
  },
/*   {
    path: principalRoute.faq,
    title: 'FAQ',
    data: { breadcrumb: 'FAQ' },
    loadComponent: () => import('./features/faq/components/faq/faq'),
  }, */
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
